import { render } from "./HFrecord.vue?vue&type=template&id=3c6f8521&scoped=true"
import script from "./HFrecord.vue?vue&type=script&lang=js"
export * from "./HFrecord.vue?vue&type=script&lang=js"

import "./HFrecord.vue?vue&type=style&index=0&id=3c6f8521&lang=scss&scoped=true"
import "./HFrecord.vue?vue&type=style&index=1&id=3c6f8521&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6f8521"]])

export default __exports__